import React from 'react';
import '../styles/Navbar.css'; 
import { Link } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

function Navbar() {
  const { isAuthenticated, loginWithRedirect, logout, user, isLoading } = useAuth0();

  return (
    <nav className="navbar">
      <div className="logo-container">
        <Link to="/">
          <img src="/assets/logo.png" alt="EMC Logo" className="logo" />
          <span className="logo-text">EMC</span>
        </Link>
      </div>
      <ul className="nav-links">
        <li><Link to="/aboutus">About Us</Link></li>
        <li><Link to="/research">Research</Link></li>
        <li><Link to="/education">Education</Link></li>
        <li><Link to="/team">Team</Link></li>
        <li><Link to="/contact">Contact Us</Link></li>
        {/* {!isLoading && (
          isAuthenticated ? (
            <>
              <li style={{ color: '#fff', fontWeight: 'bold' }}>
                {user.name || user.email}
              </li>
              <li>
                <button
                  onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: '#e74c3c',
                    cursor: 'pointer',
                    fontWeight: 'bold'
                  }}
                >
                  Log Out
                </button>
              </li>
            </>
          ) : (
            <li>
              <button
                onClick={() => loginWithRedirect()}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#4a4cf2',
                  cursor: 'pointer',
                  fontWeight: 'bold'
                }}
              >
                Log In
              </button>
            </li>
          )
        )} */}
      </ul>
    </nav>
  );
}

export default Navbar;